import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Wallet, Shield, BookOpen, User, Crown } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

const BottomNavBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, login } = useAuth();

  // Hide on admin and auth pages
  const hiddenPaths = ['/admin', '/auth/callback'];
  if (hiddenPaths.some(p => location.pathname.startsWith(p))) return null;

  const items = [
    { id: 'expenses', label: 'Organizador', icon: Wallet, path: '/expenses' },
    { id: 'analyze', label: 'Análise', icon: Shield, path: '/analyze' },
    { id: 'blog', label: 'Blog', icon: BookOpen, path: '/blog' },
    { id: 'profile', label: 'Perfil', icon: User, path: '/dashboard', requiresAuth: true },
    { id: 'pricing', label: 'Planos', icon: Crown, path: '/pricing' },
  ];

  const isActive = (path) => location.pathname === path;

  const handleClick = (item) => {
    if (item.requiresAuth && !user) {
      login(item.path);
    } else {
      navigate(item.path);
    }
  };

  return (
    <nav 
      className="fixed bottom-10 left-3 right-3 z-40 bg-[#0A0A0A] border border-white/10 rounded-2xl shadow-[0_0_20px_rgba(0,0,0,0.8)]"
      data-testid="bottom-nav-bar"
    >
      <div className="flex items-center justify-around max-w-lg mx-auto px-1 py-2">
        {items.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          return (
            <button
              key={item.id}
              onClick={() => handleClick(item)}
              className="flex flex-col items-center gap-0.5 py-2 px-2 sm:px-4 rounded-lg transition-all relative group"
              data-testid={`bottom-nav-${item.id}`}
            >
              {active && (
                <motion.div
                  layoutId="bottomNavActive"
                  className="absolute -top-px left-1/2 -translate-x-1/2 w-8 h-[3px] bg-[#00FF94] rounded-full"
                  transition={{ type: 'spring', stiffness: 350, damping: 30 }}
                />
              )}
              <div className="relative">
                <Icon className={`w-5 h-5 transition-colors ${active ? 'text-[#00FF94]' : 'text-gray-500 group-hover:text-gray-300'}`} />
                {active && (
                  <div className="absolute inset-0 w-5 h-5 bg-[#00FF94]/20 rounded-full blur-md" />
                )}
              </div>
              <span className={`text-[10px] font-medium transition-colors ${active ? 'text-[#00FF94]' : 'text-gray-500 group-hover:text-gray-300'}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavBar;
